<template>
  <b-card
    v-if="sample"
    no-body
    border-variant="light"
    class="border-top-0 border-right-0 border-left-0 border-bottom rounded-0"
  >
    <b-card-body class="mb-1 p-0">
      <span class="font-weight-bold mr-2">{{ title }}:</span>
      <template v-if="add_ons && add_ons.length">
        <b-badge
          v-for="(v, k) in add_ons"
          :key="k"
          pill
          title="Sample add-on"
          class="mx-1"
          variant="dark"
        >
          {{ v.name }}
        </b-badge>
      </template>
      <template v-if="isSoil">
        <span v-if="sample" title="Sample depth" class="mx-2">
          Depth: {{ sample.depth_start }}" -
          {{ sample.depth_end }}"
        </span>
      </template>
      <template v-if="isWater">
        <span title="Sample usage" class="mx-2">
          Sample usage:
          {{ getWaterUsage() }}
        </span>
      </template>
      <template v-if="isFeed">
        <br />
        <span title="Sample type" class="mx-2">
          Sample type:
          {{ getFeedType() }}
        </span>
        <br />
        <span title="Sample Animal fed" class="mx-2">
          Sample animal fed:
          {{ getAnimalFed() }}
        </span>
      </template>
      <template v-if="isIrrigationSuitability">
        <br />
        <span>
          Bore Hole: {{ sample.bore_hole }}
        </span>
        <br />
        <span title="Sample depth" class="mx-2">
          Depth: {{ sample.depth_start }}" -
          {{ sample.depth_end }}"
        </span>
        <br />
        <span title="Field Texture" class="mx-2">
          Field Texture:
          {{ sample.texture }}
        </span>
        <br />
        <span title="Soil Horizon" class="mx-2">
          Soil Horizon: {{ sample.horizon }}
        </span>
      </template>
      <template v-if="isMixer">
        <span title="Sample type" class="mx-2">
          {{ sample.sample_feed_mixer_efficiency.type }}
        </span>
      </template>
      <template v-if="isPotato">
        <span title="Harvest date" class="mx-2">
          Harvest date: {{ sample.sample_potato.harvest_date }}
        </span>
        <span title="Field" class="mx-2">
          Field: {{ sample.sample_potato.field }}
        </span>
      </template>
      <template v-if="isSepticSoil">
        <span title="Sample depth" class="mx-2">
          {{ sample.sample_septic.depth_start }}" -
          {{ sample.sample_septic.depth_end }}"
        </span>
        <span v-if="sample.sample_septic.texture" class="mx-1">
          <b-badge pill class="mx-1" variant="info"> Texture </b-badge>
        </span>
        <span v-if="sample.sample_septic.sieve" class="mx-1">
          <b-badge pill class="mx-1" variant="info"> Sieve Analyte </b-badge>
        </span>
        <span v-if="sample.sample_septic.sar" class="mx-1">
          <b-badge pill class="mx-1" variant="info"> SAR </b-badge>
        </span>
        <span v-if="sample.sample_septic.ec" class="mx-1">
          <b-badge pill class="mx-1" variant="info"> EC </b-badge>
        </span>
        <span v-if="sample.sample_septic.cole" class="mx-1">
          <b-badge pill class="mx-1" variant="info"> COLE </b-badge>
        </span>
        <span v-if="sample.sample_septic.dispersion" class="mx-1">
          <b-badge pill class="mx-1" variant="info"> Dispersion </b-badge>
        </span>
      </template>
    </b-card-body>
  </b-card>
</template>

<script>
import TestPackageCollection from "@/collections/lab/TestPackageCollection";

export default {
  name: "SampleReviewCard",
  props: {
    sample: {
      type: Object,
      default: () => null,
    },
    sampleType: {
      type: Object,
      default: () => null,
    },
    types: {
      type: Object,
      default: () => null,
    },
    list: {
      type: Object,
      default: () => null,
    },
    subList: {
      type: Object,
      default: () => null,
    },
    managedLists: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      add_ons: [],
    };
  },
  computed: {
    title() {
      return (
        [
          this.sample.number ? `#${this.sample.number}` : null,
          this.sample.identifier || null,
        ]
          .filter((i) => i)
          .join(" ") || null
      );
    },
    getSampleTypeName() {
      return this.sampleType ? this.sampleType.name : "";
    },
    isSoil() {
      return this.getSampleTypeName.toLowerCase() === "soil";
    },
    isMixer() {
      return this.getSampleTypeName.toLowerCase() === "feed mixer efficiency";
    },
    isFeed() {
      return this.getSampleTypeName.toLowerCase() === "feed";
    },
    isWater() {
      return this.getSampleTypeName.toLowerCase() === "water";
    },
    isPotato() {
      return this.getSampleTypeName.toLowerCase() === "potato";
    },
    isTissue() {
      return this.getSampleTypeName.toLowerCase() === "tissue";
    },
    isIrrigationSuitability() {
      return this.getSampleTypeName.toLowerCase() === "irrigation suitability";
    },
    isSepticSoil() {
      return this.getSampleTypeName.toLowerCase() === "septic soil";
    },
    isGeneral() {
      return !(
        this.isSoil ||
        this.isTissue ||
        this.isSepticSoil ||
        this.isMixer ||
        this.isFeed ||
        this.isPotato ||
        this.isWater ||
        this.isIrrigationSuitability
      );
    },

    feedTypes () {
      return this.managedLists.find(
        (item) => item.sub_type === "feed" && item.list === "type"
      ).attribute_lists
    },
    animalFeds () {
      return this.managedLists.find(
        (item) => item.sub_type === "feed" && item.list === "animal_fed"
      ).attribute_lists
    },
    usageOptions() {
      return this.managedLists.find(
        (item) => item.sub_type === "water" && item.list === "usage"
      ).attribute_lists
    },
  },
  methods: {
    getType() {
      return this.list.attribute_lists.find(
        (item) =>
        item.id === this.sample[this.types.field] ? this.sample[this.types.field][this.types.sub_field_one] : null
      ).value;
    },
    getSubType() {
      return this.subList.attribute_lists.find(
        (item) =>
          item.id === this.sample[this.types.field] ? this.sample[this.types.field][this.types.sub_field_two] : null
      ).value;
    },
    
    getFeedType() {
      let feedType = this.sample.sample_feeds && this.feedTypes.find((item) => item.id === this.sample.sample_feeds.type)
      return feedType ? feedType.value : null
    },
    getAnimalFed() {
      let animalFed = this.sample.sample_feeds && this.animalFeds.find((item) => item.id === this.sample.sample_feeds.animal_fed)
      return animalFed ? animalFed.value : null
    },
    getWaterUsage() {
      let usage = this.sample.sample_water && this.usageOptions.find((item) => item.id === this.sample.sample_water.usage)
      return usage ? usage.value : null
    },
  },
  watch: {
    "sample.add_ons": {
      handler(ids) {
        let entities = new TestPackageCollection();
        let filter = entities.getFilter();
        filter.filterIn("id", ids);
        entities.fetch().then(() => {
          this.add_ons = entities.models || [];
        });
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
